/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAlignCenterV: {
  name: 'align-center-v';
  data: string;
} = {
  name: 'align-center-v',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M15 8h-5m0 0 2-2m-2 2 2 2M1 8h5m0 0L4 6m2 2-2 2M8 1v14"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
